const swiperChampionshipRaces = {
    swiperInstance: null,
    init: () => {
        import("swiper/bundle").then(({ Swiper }) => {
            let domEls = document.querySelectorAll(
                ".js-swiper-championship-races"
            );
            if (domEls) {
                const params = getSwiperParams();
                domEls.forEach((el) => {
                    swiperChampionshipRaces.swiperInstance = new Swiper(
                        el,
                        params
                    );
                });
            }
        });
    },
};

const getSwiperParams = () => {
    return {
        watchOverflow: true,
        spaceBetween: 16,
        slidesPerView: "auto",
        resizeObserver: true,
        slideToClickedSlide: true,
        a11y: true,
        mousewheel: {
            forceToAxis: true,
        },
        grabCursor: true,
    };
};

export default swiperChampionshipRaces;
